import HttpRequest from '../http-request';

const list = async () => {
  const response = await HttpRequest.get('/api/public/popup/list.json');

  return response;
}

export default {
  list
}
